import React, {Fragment} from 'react'
import { compose, setDisplayName } from 'recompose'
import { connect } from "react-redux";
import { not } from "ramda";

import {updateFavorite, appearenceTextFlow} from '../../../../actions/reader'

import { Appearence } from "./components/Appearence/Appearence";
import { Chapters } from "./components/Chapters/Chapters";
import { BookInfo } from "./components/BookInfo/BookInfo";
import { Bookmarks } from "./components/Bookmarks/Bookmarks";
import { Notes } from "./components/Notes/Notes";
import { Search } from "./components/Search/Search"
import {isIE} from "../../../../utilities/utilities";

import './Navigation.css'

const mapStateToProps = (state) => ({
  book: state.reader.book,
  bookmarks: state.reader.bookmarks,
  highlights: state.reader.highlights,
  fullscreen: state.reader.fullscreen,
  inBookmarks: state.reader.inBookmarks,
  flow: state.appearence.flow,
  bookInfo: state.reader.bookInfo,
  isSampleMode: state.reader.isSampleMode
})

const mapDispatchToProps = (dispatch) => ({
  updateFavorite: (status, bookId) => dispatch(updateFavorite(status, bookId)),
  setFlow: (flow) => dispatch(appearenceTextFlow(flow)),
})

export const enhance = compose(
  setDisplayName('Header'),
  connect(mapStateToProps, mapDispatchToProps)
)

const ViewMode = ({ onChangeFlowSelect, onChangeViewMode, flow }) => (
  <div className="textFlow">
    <button className={`icon-btn text-flow-icon one-page${flow === '1page' ? ' active' : ''}`} data-value="1page" onClick={(e) => {onChangeFlowSelect(e.target.dataset.value);
      onChangeViewMode(e.target.dataset.value, false, flow)}}>
    </button>
    <button className={`icon-btn text-flow-icon two-page${flow === '2page' ? ' active' : ''}`} data-value="2page" onClick={(e) => {onChangeFlowSelect(e.target.dataset.value);
      onChangeViewMode(e.target.dataset.value, false, flow)}}></button>
    <button className={`icon-btn text-flow-icon scrolling${flow === 'scrolling' ? ' active' : ''}`} data-value="scrolling" onClick={(e) => {onChangeFlowSelect(e.target.dataset.value);
      onChangeViewMode(e.target.dataset.value, false, flow)}}></button>
  </div>
)

export class View extends React.Component {
  constructor(props) {
    super(props)

    this.state = {nav: false, chapterOpen: false}
    this.toggleNav = this.toggleNav.bind(this)
    this.toggleFullscreen = this.toggleFullscreen.bind(this)
  }

  toggleFullscreen() {
    if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.msRequestFullscreen) {
        document.documentElement.msRequestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  toggleNav() {
    this.setState({'nav': not(this.state.nav)})
  }

  render() {
    const {props: { isSampleMode, onChangeChapter, onSaveReaderPosition,
                    onLoadBookMark, onChangeTextSize, onChangeTextColor, onChangeTextFont, onChangeViewMode,
                    onLoadHighlight, onDeleteNote, rendition, fullscreen, onAddBookMark, inBookmarks, onZoom,
                    scale, onSearch, onChangePage, setFlow, flow, bookInfo: {format} }} = this
    return (
      <div className="Reader__navigation">
        <div className="Reader__navigation-left-nav">
          {!isSampleMode ? <button className="close-btn icon-btn" onClick={() => onSaveReaderPosition(true)}></button> : ''}
          <Chapters onChangeChapter={onChangeChapter} />
          {!isSampleMode ?
            <Fragment>
              <Notes onLoadHighlight={onLoadHighlight} onDeleteNote={onDeleteNote} rendition={rendition}/>
              <Bookmarks onLoadBookMark={onLoadBookMark} onDeleteNote={onDeleteNote} rendition={rendition}/>
              <BookInfo />
            </Fragment>
            : ''}
        </div>
        <div className="Reader__navigation-right-nav">
          {format !== 'pdf' && !isIE() && !isSampleMode ?
            <Search onSearch={onSearch} onChangePage={onChangePage}/>
            : ''}
          <Appearence onChangeTextSize={onChangeTextSize} onChangeTextColor={onChangeTextColor}
                      onChangeTextFont={onChangeTextFont} onChangeViewMode={onChangeViewMode} onZoom={onZoom} scale={scale}/>
          <button className={`fullscreen-btn icon-btn${fullscreen ? ' close' : ''}`} onClick={() => this.toggleFullscreen()}></button>

          <ViewMode onChangeFlowSelect={setFlow} onChangeViewMode={onChangeViewMode} flow={flow}/>

          {!isSampleMode ? <button className={`quick-add-bookmark-btn icon-btn${inBookmarks ? ' in' : ''}`} onClick={onAddBookMark}></button> : ''}
        </div>
      </div>
    )
  }
}

export const Navigation = enhance(View)



// WEBPACK FOOTER //
// ./src/components/Reader/components/Navigation/Navigation.js